import { useState, useEffect, useRef } from 'react';
import { 
  DESKTOP_VIEWPORT_WIDTH, 
  MOBILE_VIEWPORT_WIDTH, 
  MOBILE_VIEWPORT_HEIGHT,
  PHONE_FRAME_WIDTH,
  PHONE_FRAME_HEIGHT 
} from '../constants';

export const usePreviewScaling = (isDesktopView, sandboxHost) => {
  const [containerWidth, setContainerWidth] = useState(0);
  const [containerHeight, setContainerHeight] = useState(0);
  const previewContainerRef = useRef(null);
  
  // Calculate viewport dimensions based on view mode
  const viewportWidth = isDesktopView ? DESKTOP_VIEWPORT_WIDTH : MOBILE_VIEWPORT_WIDTH;
  const viewportHeight = isDesktopView ? null : MOBILE_VIEWPORT_HEIGHT;
  
  // Calculate scale factor
  let scale = 1;
  if (isDesktopView) {
    scale = containerWidth > 0 ? containerWidth / viewportWidth : 1;
  } else {
    const scaleX = containerWidth > 0 ? (containerWidth - 40) / PHONE_FRAME_WIDTH : 1;
    const scaleY = containerHeight > 0 ? (containerHeight - 40) / PHONE_FRAME_HEIGHT : 1;
    scale = Math.min(scaleX, scaleY, 0.9); // Cap at 0.9 to ensure some padding
  }
  
  const scaledHeight = isDesktopView ? `${100 / scale}%` : `${viewportHeight}px`;
  
  // Monitor container dimensions for scaling
  useEffect(() => {
    const updateContainerDimensions = () => {
      if (previewContainerRef.current) {
        setContainerWidth(previewContainerRef.current.offsetWidth);
        setContainerHeight(previewContainerRef.current.offsetHeight);
      }
    };
    
    updateContainerDimensions();
    
    const resizeObserver = new ResizeObserver(updateContainerDimensions);
    if (previewContainerRef.current) {
      resizeObserver.observe(previewContainerRef.current);
    }
    
    return () => {
      resizeObserver.disconnect();
    };
  }, [sandboxHost]);
  
  return {
    containerWidth,
    containerHeight,
    previewContainerRef,
    viewportWidth,
    viewportHeight,
    scale,
    scaledHeight
  };
}; 